import React, { Component } from 'react'
import { Map } from 'immutable'
import BigCalendar from 'components/BigCalendar'
import InstantBookingStore from 'stores/InstantBookingStore'
import CategoryStore from 'stores/CategoryStore'
import RouteStore from 'stores/RouteStore'
import CargosStore from 'stores/CargosStore'
import EditingCargoStore from 'stores/EditingCargoStore'
import ParametersStore from 'stores/ParametersStore'
import UserStore from 'stores/UserStore'
import GeneralStore from 'stores/GeneralStore'
import ActionCreators from 'actions/ActionCreators'
import IconControl from 'components/IconControl'
import ButtonControl from 'components/ButtonControl'
import TabPanelControlV2 from 'components/TabPanelControlV2'
import InstantBookingSpinner from 'components/InstantBookingSpinner'
import SidebarInfoBlock from 'components/SidebarInfoBlock'
import SidebarHeaderBlock from 'components/SidebarHeaderBlock'
import InfoBlockRoute from 'components/InfoBlockRoute'
import InfoBlockStuff from 'components/InfoBlockStuff'
import InfoBlockParameters from 'components/InfoBlockParameters'
import InfoBlockTotalStuff from 'components/InfoBlockTotalStuff'
import BookingSideNav from 'components/BookingSideNav'
import InstantBookingHow from 'components/InstantBookingHow'
import InstantBookingHeader from 'components/InstantBookingHeader'
import Modes from 'components/Modes'
import InstantBookingQa from 'components/InstantBookingQa'
import LifeIndicator from 'components/LifeIndicator'
import BookingTime from './BookingTime'
import DebugInfo from './DebugInfo'
import AdditionalService from './AdditionalService'
import PaymentTypes from './PaymentTypes'
import TotalPrice from './TotalPrice'
import { getInstantPrices, getServicePrices } from 'api'
import './InstantBookingScreen.scss'
import { format } from 'date-fns'
import ru from 'date-fns/locale/ru'
import classNames from 'classnames'
import { toMoneyFormat } from '../../../tools/number'
import ga from 'react-ga'
import { capitalize } from 'lodash'
import {
    INSTANT_PRICES_TYPE_NAMES,
    TYPE_FIXED_DATE_WITH_DRIVER,
    TYPE_FIXED_DATE_WITH_LOADERS,
} from '../../constants/Instantprices'
import isMobile from 'ismobilejs'
import IconSVG from 'svg-inline-react'

const SPINNER_DELAY_MS = 11300
const LEFT_BUTTON_ARROW = <IconControl name="leftArrow" size="s" />
const RIGHT_BUTTON_ARROW = <IconControl name="rightArrow" size="s" />

function getStateFromStores() {
    return {
        prices: InstantBookingStore.getPrices(),
        timeIsSelected: InstantBookingStore.getTimeIsSelected(),
        services: InstantBookingStore.getServices(),
        price: InstantBookingStore.getPrice(),
        partDay: InstantBookingStore.getPartDay(),
        isTotalPrice: InstantBookingStore.getPartDay().size > 0,
        dateWasSelected: InstantBookingStore.getDateWasSelected(),
        distance: InstantBookingStore.getDistance(),
        showInstantBookingContacts: InstantBookingStore.showInstantBooking(),
        selectedCategory: CategoryStore.getSelected(),
        type: InstantBookingStore.getType(),
        locations: RouteStore.getLocations(),
        stuff: CargosStore.getDeliveryCargos(),
        totalWeight: CargosStore.getTotalWeight(),
        totalVolume: CargosStore.getTotalVolume(),
        parameters: ParametersStore.getDeliveryParameters(),
        isSetLoaders: ParametersStore.isSetLoaders(),
        dates: RouteStore.getDates(),
        userHasToken: UserStore.hasToken(),
        userHasVVauthorization: UserStore.hasVVauthorization(),
        userHasAccount: UserStore.hasAccount(),
        isEditMode: GeneralStore.isEditMode(),
        showInstantBookingLoader: InstantBookingStore.showLoader(),
        user: UserStore.getUser(),
        instantBookingEmailCompleted: InstantBookingStore.emailCompleted(),
        instantBookingHashLogModeOn: InstantBookingStore.isInHashLogMode(),
        dumpedLoaders: InstantBookingStore.getDumpedLoaders(),
        debugData: InstantBookingStore.getDebugData(),
        showGoToAuctionButton: InstantBookingStore.showGoToAuctionButton(),
        selectedPaymentType: InstantBookingStore.getSelectedPaymentTypeName(),
        showInstantBooking: InstantBookingStore.showInstantBooking(),
        isLoadersSaved: InstantBookingStore.isLoadersSaved(),
        loadersExpanded: InstantBookingStore.getLoadersExpanded(),
        googleMapsRoute: InstantBookingStore.getGoogleMapsRoute()
    }
}

class InstantBookingScreen extends Component {

    constructor(props) {
        super(props)
        const storeStates = getStateFromStores()

        this.state = {
            ...storeStates,
            bestPrice: 0,
            bestPriceWithLoaders: 0,
            flexibleBestPrice: 0,
            showSideNav: false,
            activeTab: isMobile.phone ? undefined : storeStates.type - 2,
            errors: {},
        }
    }

    _onChange = () => {
        this.setState(getStateFromStores());
    }

    componentDidMount() {
        InstantBookingStore.addChangeListener(this._onChange)
        ParametersStore.addChangeListener(this._onChange)
        UserStore.addChangeListener(this._onChange)
        RouteStore.addChangeListener(this._onChange)
        CargosStore.addChangeListener(this._onChange)
        EditingCargoStore.addChangeListener(this._onChange)

        ActionCreators.completeInstantBookingEmail()

        this.updatePrices()

        // if (!this.state.userHasVVauthorization
        //     && !this.state.userHasAccount
        //     && (this.state.selectedCategory.name === 'household' || this.state.selectedCategory.name === 'moving')
        // ) {
        //     ActionCreators.hideInstantBookingGoToAuctionButton()
        // } else {
        //     ActionCreators.showInstantBookingGoToAuctionButton()
        // }
    }

    componentWillUnmount() {
        InstantBookingStore.removeChangeListener(this._onChange)
        ParametersStore.removeChangeListener(this._onChange)
        UserStore.removeChangeListener(this._onChange)
        RouteStore.removeChangeListener(this._onChange)
        CargosStore.removeChangeListener(this._onChange)
        EditingCargoStore.removeChangeListener(this._onChange)

        if (!isMobile.phone) {
            const body = document.getElementById('booking_body')
            body.style.overflow = 'auto'
        }
    }

    /*    componentWillUpdate(nextProps, nextState) {
            if (nextState.showSideNav && !isMobile.phone) {
                const body = document.getElementById('booking_body')
                body.style.overflow = 'hidden'
            }
        }*/

    updatePrices = () => {
        if (!this.state.instantBookingHashLogModeOn) {
            if (!this.state.showInstantBookingLoader) {
                ActionCreators.showLoadingOverlay()
            }

            const startGetInstantPricesMs = new Date().getTime()

            Promise.all([getInstantPrices(), getServicePrices()])
                .then(
                    ([response, servicesResponse]) => {
                        if (response && response.prices &&
                            response.prices.price_pred &&
                            Object.keys(response.prices.price_pred).length > 0 &&
                            response.prices.price_services &&
                            Object.keys(response.prices.price_services).length > 0) {
                            servicesResponse.prices.price_services.round_trip.price
                                = InstantBookingStore.getBasePrice()

                            ActionCreators.setInstantBookingHash(response.hash)
                            ActionCreators.setInstantBookingPrices(response.prices.price_pred)
                            ActionCreators.setInstantBookingServices(servicesResponse.prices.price_services)
                            ActionCreators.setInstantPriceDistance(response.distance > 0 ? response.distance : 0)
                            ActionCreators.setInstantGoogleMapsRoute(response.prices.order.routes.overview_polyline.points);
                            ActionCreators.calculateInstantBookingPrice();

                            if (response.prices.order) {
                                ActionCreators.setInstantBookingDebugData(response.prices.order)
                            }

                            this.onDatesChange([this.state.dates.from])
                        }

                        if (!this.state.showInstantBookingLoader) {
                            ActionCreators.hideLoadingOverlay()
                        }

                        const endGetInstantPricesMs = new Date().getTime()
                        const diff = endGetInstantPricesMs - startGetInstantPricesMs

                        if (this.state.showInstantBookingLoader && diff < SPINNER_DELAY_MS) {
                            const timeout = SPINNER_DELAY_MS - diff
                            setTimeout(() => {
                                ActionCreators.blockInstantBookingSpinner()
                                return Promise.resolve()
                            }, timeout > 0 ? timeout : 0)
                        } else {
                            ActionCreators.blockInstantBookingSpinner()
                            return Promise.resolve()
                        }
                    },
                    error => {
                        if (!this.state.showInstantBookingLoader) {
                            ActionCreators.hideLoadingOverlay()
                        }

                        ActionCreators.blockInstantBookingSpinner()
                        return Promise.reject()
                    },
                )
        } else {
            this.onDatesChange([this.state.dates.from])
        }
    }

    getDaysInSelection = () => {
        switch (this.state.type) {
            case 1:
                return 2
                break
            default:
                return 1
        }
    }

    setBestPrices = () => {
        // TODO: передавать текущий месяц
        if (this.state.prices.size > 0) {
            const loadersPrice = this.state.services.get('price_loader').price
            const pricesData = this.state.prices.filter(data => {
                return data.date_desc.best_price === 1
            })
            let newState = {}

            if (pricesData.size === 0) {
                return false
            }

            let priceData = pricesData.valueSeq().get(0)
            if (!priceData) {
                return false;
            }

            newState.flexibleBestPrice = priceData.date_desc.flex_price
            newState.bestPrice = Object.values(priceData.part_day[0])[0].price
            newState.bestPriceWithLoaders = newState.bestPrice + loadersPrice

            pricesData.forEach(data => {
                if (data.date_desc.flex_price < newState.flexibleBestPrice) {
                    newState.flexibleBestPrice = data.date_desc.flex_price
                }

                const wholeDayPriceData = Object.values(data.part_day[0])[0]
                if (wholeDayPriceData && wholeDayPriceData.price && wholeDayPriceData.price < newState.bestPrice) {
                    newState.bestPrice = wholeDayPriceData.price
                }

                if (wholeDayPriceData && wholeDayPriceData.price && wholeDayPriceData.price + loadersPrice < newState.bestPriceWithLoaders) {
                    newState.bestPriceWithLoaders = wholeDayPriceData.price + loadersPrice
                }
            })

            if (Object.keys(newState).length > 0) {
                this.setState(newState)
            }
        }
    }

    setStage = () => {
        ActionCreators.selectInstantBookingPartDay(Map({}));

        if ((isMobile.phone && this.state.activeTab === undefined) || !isMobile.phone) {
            ga.event({
                category: 'instant_booking_buttons',
                action: 'change_params_s4_from_instant_booking',
                label: this.state.selectedCategory.name,
                value: 1,
            })


            if (
                this.state.showInstantBooking &&
                (
                    this.state.selectedCategory.name === 'moving' ||
                    this.state.selectedCategory.name === 'household'
                )
            ) {
                ActionCreators.setStage(`/category/${this.state.selectedCategory.name}`, this.props.location.query)
            } else {
                ActionCreators.setStage(`/category/${this.state.selectedCategory.name}/params`, this.props.location.query)
            }
        } else {
            ga.event({
                category: 'instant_booking_buttons',
                action: 'change_calc_mode_s4_from_instant_booking',
                label: this.state.selectedCategory.name,
                value: 1,
            })

            this.setState({
                activeTab: undefined,
                type: TYPE_FIXED_DATE_WITH_DRIVER,
            })

            ActionCreators.setInstantBookingType(TYPE_FIXED_DATE_WITH_DRIVER)
        }

        if (isMobile.phone) {
            document.body.scrollTop = 0 // For Safari
            document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
        }
    }

    /*    onSelectTab = type => {
            ga.event({
                category: 'clicks',
                action: `tab_instant_booking_${INSTANT_PRICES_TYPE_NAMES[type]}`,
                label: this.state.selectedCategory.name,
                value: 1,
            })

            this.setState({
                type,
                activeTab: type - 2,
            })

            const loadersChecked = type === TYPE_FIXED_DATE_WITH_LOADERS

            ActionCreators.setInstantBookingType(type)
            ActionCreators.dumpInstantBookingLoaders(loadersChecked)

            if (loadersChecked) {
                if (this.state.dumpedLoaders) {
                    ActionCreators.updateParameter({
                        ...this.state.dumpedLoaders,
                    })
                } else {
                    ActionCreators.updateParameter({
                        loaders: true,
                        load_loaders: true,
                        unload_loaders: true,
                        load_elevator: [],
                        unload_elevator: [],
                        load_floor: undefined,
                        unload_floor: undefined,
                        packing_services: false,
                    })
                }
            } else {
                ActionCreators.updateParameter({
                    loaders: false,
                    load_loaders: false,
                    unload_loaders: false,
                    load_elevator: [],
                    unload_elevator: [],
                    load_floor: undefined,
                    unload_floor: undefined,
                    packing_services: false,
                })
            }

            this.onDatesChange([null, null])

            if (isMobile.phone) {
                document.body.scrollTop = 0 // For Safari
                document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
            }
        }*/

    /*    onCalendarFinish = () => {
            let stage = '';
            const location = this.props.location.query;

            if (this.state.showInstantBookingContacts) {
                stage = `/category/${this.state.selectedCategory.name}/instant-final-info`;
            } else {
                stage = `/category/${this.state.selectedCategory.name}/contacts`;
            }

            // TODO Add server validation
            if (!this.state.price) {
                alert('Выберите дату!')
                return
            }

            if (!this.state.isLoadersSaved) {
                alert('У вас есть несохраненные изменения в грузчиках. Для начала отмените либо сохраните их!')
                return
            }

            ActionCreators.showLoadingOverlay()

            InstantBookingStore.validate().then(
                done => {
                    ga.event({
                        category: 'orders',
                        action: 'add_orders_new_s4_from_instant_booking',
                        label: this.state.selectedCategory.name,
                        value: 1,
                    })

                    if (window.ym) {
                        window.ym('1315865', 'reachGoal', 'add_orders_new_s4_from_instant_booking');
                    }

                    this.setState({
                        errors: {},
                    }, () => {
                        ActionCreators.hideLoadingOverlay()
                        ActionCreators.setStage(stage, location)
                    })
                },
                errors => {
                    ActionCreators.hideLoadingOverlay()

                    // Validation errors, don't go to next step!
                    if (errors) {
                        this.setState({
                            errors,
                        })
                        return
                    }

                    ActionCreators.setStage(stage, location)
                },
            )
        }
        */

    onSubmitAuction = () => {
        ga.event({
            category: 'instant_booking_orders',
            action: 'add_orders_new_s4_instant_booking_auction',
            label: this.state.selectedCategory.name,
            value: 1,
        })

        if (window.ym) {
            window.ym('1315865', 'reachGoal', 'add_orders_new_s4_instant_booking_auction');
        }

        const categoryId = this.state.selectedCategory.id

        if (this.state.userHasToken || this.state.userHasVVauthorization) {
            if (window.ym) {
                window.ym('1315865', 'reachGoal', 'add_orders_new_s5');
                window.ym('1315865', 'reachGoal', 'add_orders_new_s5_instant_auction');
            }

            ActionCreators.showLoadingOverlay()

            // Disable instant prices mode
            ActionCreators.setInstantBookingPrice(0)

            ActionCreators
                .submit()
                .then(response => {
                    if (response && response.oid && typeof window.ga === 'function') {
                        window.ga('set', 'dimension20', response.oid)
                        window.ga('send', 'event', {
                            eventCategory: 'orders',
                            eventAction: 'add_orders_new_s5_instant_auction',
                            eventLabel: this.state.selectedCategory.name,
                            eventValue: 1,
                        })
                    }

                    // In widget mode
                    if (window.parent) {
                        window.parent.location.href = response.redirect_url
                    } else {
                        window.location.href = response.redirect_url
                    }
                })
        } else {
            const stage = `/category/${categoryId}/contacts`
            ActionCreators.setStage(stage, this.props.location.query)
        }
    }

    onDatesChange = (dates, showSideNav = false) => {
        if ((format(dates, 'YYYY-MM-DD') === format(this.state.dates.from, 'YYYY-MM-DD')) && this.state.showSideNav) {
            return;
        }

        const o = {
            from: dates[0],
        }

        if (dates.length > 1 && dates[dates.length - 1]) {
            o.to = dates[dates.length - 1]
        } else {
            o.to = dates[0]
        }

        ActionCreators.updateDates(o)

        if (!this.state.timeIsSelected) {
            const day = this.state.prices.get(format(o.from, 'YYYY-MM-DD', { locale: ru }))

            if (day) {
                let minPartDay = day.part_day[0]
                let minPartDayPrice = Object.values(day.part_day[0])[0].price
                day.part_day.forEach(partDay => {
                    const price = Object.values(partDay)[0].price
                    if (price < minPartDayPrice) {
                        minPartDayPrice = price
                        minPartDay = partDay
                    }
                })

                ActionCreators.selectInstantBookingPartDay(minPartDay);
            }
        } else if (this.state.partDay.size > 0 && this.state.prices.size > 0) {
            const day = this.state.prices.get(format(o.from, 'YYYY-MM-DD', { locale: ru }))
            const selectedPartDayValues = this.state.partDay.valueSeq()
            const selectedPartDayFrom = format(selectedPartDayValues.get(0).dt_start, 'HH:mm', { locale: ru })
            const selectedPartDayTo = format(selectedPartDayValues.get(0).dt_end, 'HH:mm', { locale: ru })
            day.part_day.forEach(partDay => {
                const partDayFrom = format(Object.values(partDay)[0].dt_start, 'HH:mm', { locale: ru })
                const partDayTo = format(Object.values(partDay)[0].dt_end, 'HH:mm', { locale: ru })

                if (partDayFrom === selectedPartDayFrom && partDayTo === selectedPartDayTo) {
                    ActionCreators.selectInstantBookingPartDay(partDay)
                    ActionCreators.setTimeIsSelected(false);
                }
            })
        }

        // Set min day price if not selected by user
        /*        if (this.state.partDay.size === 0) {
                    const day = this.state.prices.get(format(o.from, 'YYYY-MM-DD', {locale: ru}))
                    if (day) {
                        let minPartDay = day.part_day[0]
                        let minPartDayPrice = Object.values(day.part_day[0])[0].price
                        day.part_day.forEach(partDay => {
                            const price = Object.values(partDay)[0].price
                            if (price < minPartDayPrice) {
                                minPartDayPrice = price
                                minPartDay = partDay
                            }
                        })

                        ActionCreators.selectInstantBookingPartDay(minPartDay)
                    }
                } else if (this.state.partDay.size > 0 && this.state.prices.size > 0) {
                    const day = this.state.prices.get(format(o.from, 'YYYY-MM-DD', {locale: ru}))
                    const selectedPartDayValues = this.state.partDay.valueSeq()
                    const selectedPartDayFrom = format(selectedPartDayValues.get(0).dt_start, 'HH:mm', {locale: ru})
                    const selectedPartDayTo = format(selectedPartDayValues.get(0).dt_end, 'HH:mm', {locale: ru})
                    day.part_day.forEach(partDay => {
                        const partDayFrom = format(Object.values(partDay)[0].dt_start, 'HH:mm', {locale: ru})
                        const partDayTo = format(Object.values(partDay)[0].dt_end, 'HH:mm', {locale: ru})

                        if (partDayFrom === selectedPartDayFrom && partDayTo === selectedPartDayTo) {
                            ActionCreators.selectInstantBookingPartDay(partDay)
                        }
                    })
                }*/

        ActionCreators.calculateInstantBookingPrice()

        this.setBestPrices()

        if (showSideNav) {
            this.setState({
                showSideNav,
            })
        }
    }

    /*    onHideSideNav = () => {
            this.setState({
                showSideNav: false,
            })
            ActionCreators.selectInstantBookingPartDay(Map({}))

            const body = document.getElementById('booking_body')
            body.style.overflow = 'auto'
        }*/

    onHideSideNavByButton = () => {
        ActionCreators.selectInstantBookingPartDay(Map({}));
        ActionCreators.calculateInstantBookingPrice();
        this.setBestPrices();

        ga.event({
            category: 'instant_booking_buttons',
            action: 'close_summary_calendar_s4_instant_booking',
            label: this.state.selectedCategory.name,
            value: 1,
        })

        this.setState({
            showSideNav: false,
        })
    }

    onChangeService = (data, ...args) => {
        ActionCreators.calculateInstantBookingPrice()

        const checked = args[2]
        if (checked) {
            ga.event({
                category: 'clicks',
                action: `${data.attribute.get('name')}_instant_booking`,
                label: this.state.selectedCategory.name,
                value: data.attribute.get('price'),
            })
        }

        if (data.attribute.get('name') === 'loaders') {
            const type = data.attribute.get('value') ? TYPE_FIXED_DATE_WITH_LOADERS : TYPE_FIXED_DATE_WITH_DRIVER

            ActionCreators.setInstantBookingType(type)

            this.setState({
                activeTab: type - 2,
            })
        }
    }

    onChangePaymentType = (type) => {
        ActionCreators.updateParameter({
            payment_online: false,
            payment_invoice: false,
            payment_cash: false,
            payment_prepay: false,
        })
        ActionCreators.updateParameter({
            [type]: true,
        })
        ActionCreators.calculateInstantBookingPrice()
    }

    /*    renderTabsInfo = () => {
            const tabs = [
                // {
                //     content: this.renderTabTitle('Гибкая дата и помощь водителя', this.state.flexibleBestPrice),
                //     onSelect: this.onSelectTab.bind(this, TYPE_FLEXIBLE_DATE_WITH_DRIVER),
                // },
                {
                    content: [
                        <div key="1" className="InstantBookingScreen-tabsTitleBox">
                            <IconSVG
                                className="InstantBookingScreen-truckLogo"
                                src={require('!svg-inline!./truck-white.svg')}
                                title=""/>
                            <div className="InstantBookingScreen-tabsTitle">Перевозка</div>
                        </div>,
                        <div key="2" className="InstantBookingScreen-tabsPrice">
                            <span
                                className="InstantBookingScreen-tabsPriceFrom">от</span>&nbsp;{toMoneyFormat(this.state.bestPrice)}₽
                        </div>,
                        <div key="3" className="InstantBookingScreen-tabsArrow">
                            {RIGHT_BUTTON_ARROW}
                        </div>,
                    ],
                    onSelect: this.onSelectTab.bind(this, TYPE_FIXED_DATE_WITH_DRIVER),
                    additionalClassName: 'additional-class',
                },
                {
                    content: [
                        <div key="1" className="InstantBookingScreen-tabsTitleBox">
                            <IconSVG
                                className="InstantBookingScreen-loaderLogo"
                                src={require('!svg-inline!./loader-white.svg')}
                                title=""/>
                            <IconSVG
                                className="InstantBookingScreen-truckLogo"
                                src={require('!svg-inline!./truck-white.svg')}
                                title=""/>
                            <div key="1" className="InstantBookingScreen-tabsTitle">Перевозка + грузчики</div>
                        </div>,
                        <div key="2" className="InstantBookingScreen-tabsPrice">
                            <span
                                className="InstantBookingScreen-tabsPriceFrom">от</span>&nbsp;{toMoneyFormat(this.state.bestPriceWithLoaders)}₽
                        </div>,
                        <div key="3" className="InstantBookingScreen-tabsArrow">
                            {RIGHT_BUTTON_ARROW}
                        </div>,
                    ],
                    onSelect: this.onSelectTab.bind(this, TYPE_FIXED_DATE_WITH_LOADERS),
                },
            ]

            return tabs
        }*/

    /*    renderTabs = () => {
            if (isMobile.phone && this.state.activeTab !== undefined) {
                return null
            }

            return (
                <TabPanelControlV2
                    className="InstantBookingScreen-tabs"
                    tabClassName="InstantBookingScreen-tab"
                    activeTab={this.state.activeTab}
                    info={this.renderTabsInfo()}/>
            )
        }*/

    /*    renderTotalTitle = () => {
            let finalDateParts = []

            if (this.state.dates.from) {
                finalDateParts.push(format(this.state.dates.from, 'DD MMMM, dddd', {locale: ru}))
            }

            if (this.state.dates.to && this.state.dates.from !== this.state.dates.to) {
                finalDateParts.push(format(this.state.dates.to, 'DD MMMM, dddd', {locale: ru}))
            }

            return ([
                <span key="1">{capitalize(finalDateParts.join('–'))}</span>,
                <button key="2" className="InstantBookingScreen-closeNav"
                        type="button"
                        onClick={this.onHideSideNavByButton}>
                    <span>&times;</span>
                </button>,
            ])
        };*/

    getDay = () => {
        if (this.state.dates.from) {
            return Map(this.state.prices.get(format(this.state.dates.from, 'YYYY-MM-DD', { locale: ru })))
        } else {
            return Map({})
        }
    }

    /*    scrollToCalendar = () => {
            document.body.scrollTop = 0 // For Safari
            document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
        }*/

    render() {
        if (this.state.showInstantBookingLoader) {
            return <InstantBookingSpinner />
        }

        const InstantBookingScreenControlsClasses = classNames({
            'InstantBookingScreen-buttonsWrapper': true,
        })

        const InstantBookingScreenInfoControlsClasses = classNames({
            'InstantBookingScreen-info': true,
            'InstantBookingScreen-infoVisibleMobile': isMobile.phone && this.state.showSideNav,
        })


        const day = this.getDay()

        let title = 'Выберите подходящие дату и цену'
        if (isMobile.phone) {
            if (this.state.activeTab === undefined) {
                title = 'Выберите режим расчета'
            } else {
                title = ''
            }
        }

        return (
            <div className="InstantBookingScreen">
                <div className="InstantBookingScreen-container">
                    {/*<BookingSideNav
                        // showNav={this.state.showSideNav}
                        showNav={false}
                        onHideNav={this.onHideSideNav}
                        openFromRight
                        title={this.renderTotalTitle()}
                        items={[
                            <BookingTime
                                selectedCategory={this.state.selectedCategory}
                                type={this.state.type}
                                selectedPartDay={this.state.partDay}
                                day={day}/>,
                            <AdditionalService
                                selectedPartDay={this.state.partDay}
                                selectedCategory={this.state.selectedCategory}
                                isSetLoaders={this.state.isSetLoaders}
                                parameters={this.state.parameters}
                                dumpedLoaders={this.state.dumpedLoaders}
                                services={this.state.services}
                                onChangeService={this.onChangeService}
                                updatePrices={this.updatePrices}/>,
                            <PaymentTypes
                                selectedPaymentType={this.state.selectedPaymentType}
                                selectedCategory={this.state.selectedCategory}
                                parameters={this.state.parameters}
                                onChangePaymentType={this.onChangePaymentType}/>,
                            <TotalPrice
                                errors={this.state.errors}
                                parameters={this.state.parameters}
                                showGoToAuctionButton={this.state.showGoToAuctionButton}
                                price={this.state.price}
                                submitText="Продолжить бронирование"
                                onSubmit={this.onCalendarFinish}
                                onSubmitAuction={this.onSubmitAuction}/>,
                        ]}
                        titleStyle={{
                            backgroundColor: '#fff',
                            color: '#000',
                            lineHeight: 'normal',
                            paddingLeft: '22px',
                            paddingTop: '22px',
                            paddingBottom: 0,
                            paddingRight: '22px',
                            fontSize: '22px',
                            fontWeight: 600,
                            fontFamily: 'Roboto Slab, Helvetica, Arial, sans-serif',
                        }}
                        itemStyle={{backgroundColor: '#fff', cursor: 'default'}}
                        itemHoverStyle={{backgroundColor: '#fff', cursor: 'default'}}
                        navStyle={{
                            maxWidth: '450px',
                            overflow: 'auto',
                        }}
                    />*/}
                    <div className="InstantBookingScreen-wrapper">
                        <div className="InstantBookingScreen-calendar">
                            {!isMobile.phone ?
                                <InstantBookingHeader title={title} />
                                :
                                <div className="InstantBookingScreen-title">
                                    {title}
                                </div>
                            }

                            {/*this.renderTabs()*/}


                            <BigCalendar
                                dates={this.state.dates}
                                onDatesChange={this.onDatesChange}
                                daysInSelection={this.getDaysInSelection()}
                                prices={this.state.prices}
                                price={this.state.price}
                                services={this.state.services}
                                type={this.state.type}
                                activeTab={this.state.activeTab}
                                selectedCategory={this.state.selectedCategory}
                                logMode={this.state.instantBookingHashLogModeOn}
                                showSideNav={this.state.showSideNav} />


                            <div className="InstantBookingScreen-lifeIndicator">
                                <LifeIndicator />
                            </div>


                            <div className="InstantBookingScreen-notes">
                                <ul>
                                    <li>Стоимость перевозки, указанная в календаре, окончательна</li>
                                    <li>Без почасовых оплат и  скрытых комиссий</li>
                                    <li>Все цены включают НДС</li>
                                </ul>

                                <ul>
                                    <li>Принимаем все способы оплаты: оплата онлайн, оплата наличными на погрузке (+10% к цене), безналичный с НДС/без НДС</li>
                                </ul>
                            </div>

                            <div className="InstantBookingScreen-buttons">
                                <div className={InstantBookingScreenControlsClasses}>
                                    <ButtonControl className="InstantBookingScreen-buttonBack"
                                        view="stone"
                                        size="s"
                                        onClick={this.setStage}
                                        leftIcon={LEFT_BUTTON_ARROW}>
                                        {isMobile.phone && this.state.activeTab !== undefined ? 'Изменить режим расчета' : 'Изменить грузы'}
                                    </ButtonControl>
                                </div>
                            </div>

                            <Modes containerClassName="container-fluid" />
                            <InstantBookingHow containerClassName="container-fluid" />
                            <InstantBookingQa containerClassName="container-fluid" />
                        </div>
                        <div className={InstantBookingScreenInfoControlsClasses}>
                            <SidebarHeaderBlock
                                location={this.props.location}
                                onChangeService={this.onChangeService} />

                            {
                                !this.state.showSideNav || !this.state.dates.from ?
                                    <div>
                                        <SidebarInfoBlock
                                            title={this.state.distance ? `Маршрут (${this.state.distance} км)` : 'Маршрут'}
                                            isEditable
                                            category={this.state.selectedCategory}
                                            linkToEdit={`${this.state.selectedCategory.name}/route`}>
                                            <InfoBlockRoute
                                                locations={this.state.locations}
                                                googleMapsRoute={this.state.googleMapsRoute}
                                            />
                                        </SidebarInfoBlock>

                                        <SidebarInfoBlock
                                            title="Ваши грузы"
                                            isEditable
                                            category={this.state.selectedCategory}
                                            linkToEdit={`${this.state.selectedCategory.name}`}>
                                            <InfoBlockStuff
                                                stuff={this.state.stuff}
                                                totalWeight={this.state.totalWeight}
                                                totalVolume={this.state.totalVolume} />
                                        </SidebarInfoBlock>
                                        {/*{!isMobile.phone ?
                                            <SidebarInfoBlock
                                                title="Дополнительные услуги"
                                                isEditable={
                                                    !(
                                                        (this.state.selectedCategory.name === 'household' || this.state.selectedCategory.name === 'moving')
                                                        && this.state.showInstantBooking
                                                    )
                                                }
                                                category={this.state.selectedCategory}
                                                linkToEdit={`${this.state.selectedCategory.name}/params`}>
                                                <InfoBlockParameters parameters={this.state.parameters}/>
                                            </SidebarInfoBlock> :
                                            <SidebarInfoBlock
                                                title=""
                                                isEditable
                                                category={this.state.selectedCategory}
                                                linkToEdit={`${this.state.selectedCategory.name}`}>
                                                <InfoBlockTotalStuff total={this.state.stuff.size}/>
                                            </SidebarInfoBlock>
                                        }*/}
                                    </div>
                                    :
                                    <div>
                                        <button className="InstantBookingScreen-closeNav"
                                            type="button"
                                            onClick={this.onHideSideNavByButton}>
                                        </button>

                                        <BookingTime
                                            selectedCategory={this.state.selectedCategory}
                                            type={this.state.type}
                                            selectedPartDay={this.state.partDay}
                                            day={day}
                                            dates={this.state.dates} />

                                        <AdditionalService
                                            prices={this.state.prices}
                                            selectedPartDay={this.state.partDay}
                                            selectedCategory={this.state.selectedCategory}
                                            isSetLoaders={this.state.isSetLoaders}
                                            parameters={this.state.parameters}
                                            dumpedLoaders={this.state.dumpedLoaders}
                                            services={this.state.services}
                                            onChangeService={this.onChangeService}
                                            updatePrices={this.updatePrices}
                                            loadersExpanded={this.state.loadersExpanded} />

                                        <PaymentTypes
                                            selectedPaymentType={this.state.selectedPaymentType}
                                            selectedCategory={this.state.selectedCategory}
                                            parameters={this.state.parameters}
                                            onChangePaymentType={this.onChangePaymentType} />
                                    </div>
                            }


                            <ButtonControl
                                className="TotalPrice-helpButton TotalPrice-goToAuction"
                                view="crystal"
                                size="s"
                                rightIcon={RIGHT_BUTTON_ARROW}
                                onClick={() => {
                                    if (!this.state.dateWasSelected) {
                                        alert("Выберите пожалуйста дату загрузки до размещения заявки на аукционе!");
                                    } else {
                                        this.onSubmitAuction();
                                    }
                                }}>
                                Разместить заявку на аукционе
                            </ButtonControl>

                            <ButtonControl
                                className="TotalPrice-getOfferLater"
                                view="white"
                                size="s"
                                onClick={() => ActionCreators.showInstantBookingAwayModal()}>
                                Сохранить расчёт себе
                            </ButtonControl>
                        </div>
                    </div>
                </div>
                {this.state.instantBookingHashLogModeOn || process.env.NODE_ENV !== 'production' ?
                    <DebugInfo data={this.state.debugData} /> : null}
                {/*<Modes/>
                <ButtonControl className="InstantBookingScreen-buttonScroll"
                               view="sand"
                               size="m"
                               onClick={this.scrollToCalendar}
                >
                    Начать бронирование
                </ButtonControl>
                <InstantBookingHow/>
                <InstantBookingQa/>*/}
            </div>
        )
    }
}

export default InstantBookingScreen



// WEBPACK FOOTER //
// ./client/components/InstantBookingScreen/InstantBookingScreen.js